// extracted by mini-css-extract-plugin
export default {"button":"styles_button__ViTOQ","buttonActive":"styles_buttonActive__fcI-f","star":"styles_star__N1Xfe"};